module.exports = __webpack_public_path__ + "static/media/33_B.8d12934d.png";